// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import type { Rule } from '../FAQRule';
import FAQRule from '../FAQRule';
import { H3 } from '../Typography';

type Props = {
  image: any,
  text: any,
  title: string,
  rules: Array<Rule>,
}

const FAQSlide = (
  {
    image,
    text,
    title,
    rules,
  }: Props,
) => {
  const { t } = useTranslation();
  return (
    <div
      className={`${styles.faqSlideContainer}
      ${text?.isContinued ? styles.noLine : ''}
      ${text?.isNext ? styles.noIndentTop : ''}
      `}
    >
      {title
        && (
        <div className={styles.faqTitle}>
          <H3>{t(`${title}`)}</H3>
        </div>
        )}
      {text?.content
        && (
        <div
          className={styles.faqSlideText}
          style={{
            color: (text.color === '#0B07FF' || text.color === '#000000' || text.color === '#C31AFF') ? 'white' : 'black',
          }}
        >
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: t(`${text.content}`) }} />
        </div>
      )}
      <div className={styles.faqSlideWrapper}>
        <img
          className={styles.faqSlideImage}
          src={image}
          alt="123"
        />
        <div className={styles.faqSlideRules}>
          {rules.map((item, index) => (
            <FAQRule
              key={item.content}
              color={item.color}
              ruleNum={index + 1}
              content={item.content}
              sideContent={item.sideContent}
              inDetail={item.inDetail}
              sideIsFlex={item.sideIsFlex}
            />
          ))}
        </div>
      </div>
      {text?.conclusion
        && (
        <div
          className={styles.faqSlideText}
          style={{
            color: (text.color === '#0B07FF' || text.color === '#000000' || text.color === '#C31AFF') ? 'white' : 'black',
          }}
        >
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: t(`${text.conclusion}`) }} />
        </div>
      )}
    </div>
  );
};

export default FAQSlide;
